// External imports
import React, { useRef, useState } from "react";

// Internal imports
import PricingCard from "./components/PricingCard/PricingCard";
import ToggleButton from "./components/ToggleButton/ToggleButton";
import { PRICING_CARD_DATA } from "./Pricing.config";
import {
    AboutContainer,
    PricingCardContainer,
    PricingSectionContainer,
    PricingSectionContentContainer,
    PricingSectionDescription,
    PricingSectionTitle,
} from "./Pricing.styles";
import ecg from "./../analytics-insights/assets/ecg.png";
import dashboard from "./../analytics-insights/assets/dashboard.png";
import hallway from "./../../../assets/hallway.jpg";
import waitingRoom from "./../../../assets/waiting_room.jpg";
import MainPageLayout from "../../../components/core/header/MainPageLayout";
import AboutCard from "./components/about/aboutCard";
import VideoCard from "./components/video/videoCard";
import Testimonials from "./components/testimonials/testimonials";
import ContactPage from "./components/contact/ContactPage";
import {Picture, WidePicture } from "./components/pictures/Picture";

// Language Context
import { useLanguage } from '../../../core/translations/LanguageContext';

// Translations
import { PricingTranslations } from './translations/types';
import { enTranslations } from './translations/en';
import { deTranslations } from './translations/de';
import { SupportedLanguage } from '../../../core/translations/supportedLanguages';


const TRANSLATIONS: Record<SupportedLanguage, PricingTranslations> = {
    en: enTranslations,
    de: deTranslations,
};

/**
 * Pricing page component
 * Displays pricing plans with toggleable monthly/yearly pricing
 * Includes features and details for each plan
 */
const Pricing: React.FC = () => {
    const { language } = useLanguage();
    const translations = TRANSLATIONS[language];
    const [isMonthly, setIsMonthly] = useState<boolean>(true);

      const visionRef = useRef<HTMLDivElement>(null);
    
      const handleReadMore = () => {
        visionRef.current?.scrollIntoView({ behavior: "smooth" });
      };

    return (
        <MainPageLayout>
            <PricingSectionContainer>
                <AboutContainer>
                <AboutCard
                title={translations.aboutCard.title}
                detail={translations.aboutCard.detail}
                handleReadMore={handleReadMore}
                />
                </AboutContainer>
                <WidePicture src={hallway} alt="hallway"/>
                <AboutContainer>
                    <AboutCard
                        title={translations.whoIsThisFor.title}
                        detail={translations.whoIsThisFor.detail}
                        handleReadMore={handleReadMore}
                    />
                </AboutContainer>
                <Picture
                    images={[
                        { src: ecg, alt: "ECG" },
                        { src: dashboard, alt: "Dashboard" },
                    ]}
                />
                <AboutContainer>
                    <AboutCard
                        title={translations.whyVital.title}
                        detail={translations.whyVital.detail}
                        handleReadMore={handleReadMore}
                    />
                </AboutContainer>
                <WidePicture src={waitingRoom} alt="waitingRoom"/>

                <AboutContainer>
                    <AboutCard
                        title={translations.whoWeAre.title}
                        detail={translations.whoWeAre.detail}
                        handleReadMore={handleReadMore}
                    />
                </AboutContainer>
                 {/* @ts-ignore */}
                 <VideoCard visionRef={visionRef}/>
                 <Testimonials
                testimonial={translations.testimonials}
                translations={translations}
                />



                <ContactPage 
                //@ts-ignore
                pageTranslations={translations}
                
                />
               
                {/* </ContactContainer> */}

              
                
                <PricingSectionContentContainer>
                    <PricingSectionTitle>
                        {translations.section.title}
                    </PricingSectionTitle>
                    <PricingSectionDescription>
                        {translations.section.description}
                    </PricingSectionDescription>
                </PricingSectionContentContainer>
                <div>
                    <ToggleButton
                        isMonthly={isMonthly}
                        onClick={() => setIsMonthly(!isMonthly)}
                        monthlyText={translations.section.toggleMonthly}
                        yearlyText={translations.section.toggleYearly}
                    />
                    <PricingCardContainer>
                        {PRICING_CARD_DATA.map((data,index) => (
                            <PricingCard
                                key={data.id}
                                id={data.id}
                                title={translations.plans[data.id].title}
                                price={isMonthly ? data.lessThanThirtyUsersPrice : data.thirtyUsersOrMorePrice}
                                details={translations.plans[data.id].details}
                                liItems={translations.plans[data.id].features}
                                deal={translations.deal}
                                showDeal={data.id=="plus"?true:false}
                                yearlyPlan={isMonthly ? data.lessThanThirtyUsersPriceYear : data.thirtyUsersOrMorePriceYear}
                                yearlyText={translations.yearlyPlan}
                                duration={isMonthly
                                    ? translations.section.perMonth
                                    : translations.section.perYear}
                                buttonText={translations.bookDemoButtonText}
                            />
                        ))}
                    </PricingCardContainer>
                </div>
            </PricingSectionContainer>
        </MainPageLayout>
    );
};

export default Pricing;